/* @flow */
import * as React from "react";

// Checks for a stylesheet with the provided `id` in document.head when it mounts,
// and if one isn't there, it adds one with the contents specified by `sheet`.
// Example:
//
// <GlobalStyleSheet id="nx-components_red-body" sheet={`
//   body {
//     color: red;
//   }
// `}/>
//
// Use sparingly, and namespace your classes aggressively; you can accomplish
// most of what you want with inline styles instead of this, but this can be
// used for CSS animations, etc.
//
// WARNING: If your stylesheet creates animations that are used on the first
// mount of a component, you need to ensure that those animations are loaded
// before the component is mounted. You can do this with the
// GlobalStyleSheet.preload function:
//
// Instead of:
//
// const id = "my-animation-sheet";
// const stylesheet = `@keyframes my-animation {...}`;
//
// return (
//   <div style={{ animation: "my-animation" }}>
//     <GlobalStyleSheet id={id} sheet={stylesheet} />
//   </div>
// );
//
// Do this:
//
// const id = "my-animation-sheet";
// const stylesheet = `@keyframes my-animation {...}`;
//
// GlobalStyleSheet.preload(id, stylesheet);
//
// return (
//   <div style={{ animation: "my-animation" }} />
// );
type Props = {
  id: string,
  sheet: string,
};

export default class GlobalStyleSheet extends React.Component<Props> {
  static preload(id: string, sheet: string) {
    addStyleIfNotPresent(id, sheet);
  }

  componentDidMount() {
    const { id, sheet } = this.props;
    addStyleIfNotPresent(id, sheet);
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.id === this.props.id &&
      prevProps.sheet === this.props.sheet
    ) {
      return;
    }
    removeStyleIfPresent(prevProps.id);
    addStyleIfNotPresent(this.props.id, this.props.sheet);
  }

  render() {
    return null;
  }
}

function getStyleElementById(id: string) {
  return document.head.querySelector(`style#${id}`);
}

function addStyleIfNotPresent(id: string, sheet: string) {
  if (getStyleElementById(id)) {
    return;
  }

  const style = document.createElement("style");
  style.type = "text/css";
  style.id = id;
  style.appendChild(document.createTextNode(sheet));
  document.head.appendChild(style);
}

function removeStyleIfPresent(id: string) {
  const element = getStyleElementById(id);
  if (element != null) {
    document.head.removeChild(element);
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/GlobalStyleSheet.jsx